import { NavLink, Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { SignOut, Package, ListBullets, GearSix, ChartBar, Article, MagnifyingGlass, Scales, LinkSimple, TrendUp } from "@phosphor-icons/react";

export function AdminLayout() {
  const { user, loading, logout } = useAuth();

  if (loading) return <div className="p-10 text-[#5C5A56]">Checking session...</div>;
  if (!user) return <Navigate to="/admin/login" replace />;

  const linkCls = ({ isActive }) =>
    `flex shrink-0 whitespace-nowrap items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-medium transition-colors ${
      isActive ? "bg-[#5B7B53] text-white" : "text-[#2C2B29] hover:bg-[#EADDC8]/50"
    }`;

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-6 lg:py-10 grid grid-cols-1 lg:grid-cols-[240px_minmax(0,1fr)] gap-6 lg:gap-10">
      <aside data-testid="admin-sidebar" className="min-w-0 lg:space-y-1 max-lg:flex max-lg:gap-2 max-lg:overflow-x-auto max-lg:-mx-4 max-lg:px-4 max-lg:pb-2 hh-no-scrollbar">
        <div className="mb-6 hidden lg:block">
          <p className="text-xs uppercase tracking-[0.2em] text-[#5B7B53]">Signed in as</p>
          <p className="font-medium text-[#2C2B29]">{user.email}</p>
        </div>
        <NavLink to="/admin" end className={linkCls} data-testid="admin-nav-dashboard"><ChartBar size={16} /> Dashboard</NavLink>
        <NavLink to="/admin/products" className={linkCls} data-testid="admin-nav-products"><Package size={16} /> Products</NavLink>
        <NavLink to="/admin/lists" className={linkCls} data-testid="admin-nav-lists"><ListBullets size={16} /> Curated Lists</NavLink>
        <NavLink to="/admin/posts" className={linkCls} data-testid="admin-nav-posts"><Article size={16} /> Blog Posts</NavLink>
        <NavLink to="/admin/comparisons" className={linkCls} data-testid="admin-nav-comparisons"><Scales size={16} /> Comparisons</NavLink>
        <NavLink to="/admin/links" className={linkCls} data-testid="admin-nav-links"><LinkSimple size={16} /> Links</NavLink>
        <NavLink to="/admin/analytics" className={linkCls} data-testid="admin-nav-analytics"><TrendUp size={16} /> Click Analytics</NavLink>
        <NavLink to="/admin/seo" className={linkCls} data-testid="admin-nav-seo"><MagnifyingGlass size={16} /> SEO & Submit</NavLink>
        <NavLink to="/admin/settings" className={linkCls} data-testid="admin-nav-settings"><GearSix size={16} /> Settings</NavLink>
        <button
          data-testid="admin-logout"
          onClick={logout}
          className="lg:mt-6 flex shrink-0 whitespace-nowrap items-center gap-2 px-4 py-2.5 rounded-lg text-sm text-[#D17A58] hover:bg-[#D17A58]/10 lg:w-full"
        >
          <SignOut size={16} /> Sign out
        </button>
      </aside>
      <main className="min-w-0">
        <Outlet />
      </main>
    </div>
  );
}
